import { WRM } from '@confluence-classic/confluence-wrm';

// Analytics
import { editorPluginAnalytics } from './utils/analytics';

// Start Plugin includes
import adg3Editor from './adg3-editor/plugin';
import textPlaceHolder from './placeholder/editor_plugin_src';
import emotions from './emotions/editor_plugin_src.js';
import macroPlaceholder from './macroplaceholder/editor_plugin_src.js';
import deleteCommand from './deletecommand/editor_plugin_src';
import propertyPanel from './propertypanel/editor_plugin_src';
import confMonoSpace from './confmonospace/editor_plugin_src';
import { exportGlobalBookmarkManager } from './resources/bookmark/atlassian-editor-bookmark-manager';
import confOfCharmap from './confcharmap/editor_plugin_src';
import confList from './confList/editor_plugin_src';
import taskList from './tasklist/plugin.js';
import cursorTarget from './confcursortarget/editor_plugin_src';
import aeTable from './aeTable/plugin';
import iOSEditingPlugin from './iosediting/editor_plugin_src';
import autoConvert from './autoconvert/tinymce-autoconvert';
import clipboardAccess from './autoconvert/clipboard-access';
import draggable from './draggable/editor_plugin_src';
import insertFilesPlugin from './insert-files/insert-files-plugin';
import flexToFullSize from './flextofullsize/editor_plugin_src';
import referrer from './referrer/editor_plugin_src';
import tableContentWrapper from './tablecontentwrapper/editor_plugin_src';
import versionComment from './versioncomment/editor_plugin_src';
import wikiAutoformat from './autoformat/wiki-autoformat';
import stickyTableHeaders from './sticky-table-headers/stickytableheaders';
import leaveComment from './leavecomment/plugin';
import leaveTemplate from './leavetemplate/plugin';
import confluenceDrafts from './confluencedrafts/plugin';
import macrobrowser from './macrobrowser/editor_plugin_src';
import watchPage from './watch-page/plugin';
import sortableTables from './sortable-tables/plugin';
import autoresize from './autoresize/plugin';
import searchReplace from './searchreplace/editor_plugin_src';
import nofifyWatchers from './notify-watchers/plugin';
import editorAnalytics from './editor-analytics/analytics';
import tableAnalytics from './tableanalytics/plugin';
import inlineComment from './inline-comment/plugin';
import confindentation from './conf-indentation/plugin';
import textPattern from './textpattern/plugin';
import persistScrollPositionTransition from './persit-scroll-position/plugin';
import textColor from './textcolor/plugin';

// Globals and legacy patches
import { exportAjsRteContentAsGlobal } from '../global-objects/ajs-rte-content';
import { exportNodeUtilsAsGlobal } from './utils/tinymce-node-utils';
import { exportMacroUtilsAsGlobal } from './utils/macro-utils';
import { exportMacrobrowserAsGlobal } from './utils/macro-browser';
import { patch_firefox } from './browser-fixes/firefox';
import { patch_ie } from './browser-fixes/ie';

// Plugins with WRM Dependencies
import { auiWindowManager, auiWindowManagerWRM } from './auiwindowmanager/auiwindowmanager.js';
import { confluencePlugin, confluencePluginWRM } from './confluence/editor_plugin_src.js';
import { customToolbar, customToolbarWRM } from './customtoolbar/editor_plugin_src';
import { wikiMarkup, wikiMarkupWRM } from './insertwiki/editor_plugin_src';
import { exportGlobalCodeMacroConfig, exportGlobalCodeMacroConfigWRM } from './code-macro/plugin';
import {
	confluenceKeyboardShortcuts,
	confluenceKeyboardShortcutsWRM,
} from './confluence-keyboard-shortcuts/tinymce-plugin';
import { collaborativeEditing, collaborativeEditingWRM } from './collaborative-editing/synchrony';
import { pageLayout, pageLayoutWRM } from './pagelayout/page-layout.js';
import { confluenceLabels, confluenceLabelsWRM } from './confluence-labels/tinymce-plugin';
import { breadCrumbs, breadCrumbsWRM } from './breadcrumbs/breadcrumb';
import { autoCompleteDate, autoCompleteDateWRM } from './autocomplete-date/editor_plugin_src';
import { atlassianConnect, atlassianConnectWRM } from './atlassian-connect/plugin';
import { autocompleteMacro, autocompleteMacroWRM } from './autocomplete-macro/plugin';
import { advancedMacros, advancedMacrosWRM } from './advanced-macros/plugin';
import { linkBrowser, linkBrowserWRM } from './link-browser/plugin';
import {
	contentFormattingMacros,
	contentFormattingMacrosWRM,
} from './content-formatting-macros/plugin';
import { initTableToolbar, initTableToolbarWRM } from './customtoolbar/table-toolbar';
import { dragAndDrop, dragAndDropWRM } from './drag-and-drop/plugin';
import { gadgets, gadgetsWRM } from './gadgets/plugin';
import { hipchatEmoticons, hipchatEmoticonsWRM } from './hipchat-emoticons/plugin';
import { inviteToEdit, inviteToEditWRM } from './invite-to-edit/plugin';
import { multimediaMacro, multimediaMacroWRM } from './multimedia-macros/plugin';
import { officeConnector, officeConnectorWRM } from './office-connector/plugin';
import {
	propertyPanelImageLinkMacro,
	propertyPanelImageLinkMacroWRM,
} from './propertypanel/property-panel-image-link-macro';
import { roadmapPlanner, roadmapPlannerWRM } from './roadmap-planner/plugin';
import { statusMacro, statusMacroWRM } from './status-macro/plugin';
import { viewFileMacro, viewFileMacroWRM } from './view-file-macro/plugin';
import { requestAccess, requestAccessWRM } from './request-access/request-access';
import { locationIcon, locationIconWRM } from './locationicon/plugin';
import { createFromTemplateMacroWRM } from './create-from-template-macro/plugin';
import { taskReportMacroWRM } from './task-report-macro/plugin';
import { teamCalendar, teamCalendarWRM } from './team-calendar/plugin';
import { placeholderJiraWRM } from './placeholder/text-placeholders-jira';

const pluginDependencies = [
	...exportGlobalCodeMacroConfigWRM(),
	...statusMacroWRM(),
	...customToolbarWRM(),
	...auiWindowManagerWRM(),
	...confluencePluginWRM(),
	...wikiMarkupWRM(),
	...pageLayoutWRM(),
	...linkBrowserWRM(),
	...autocompleteMacroWRM(),
	...atlassianConnectWRM(),
	...autoCompleteDateWRM(),
	...breadCrumbsWRM(),
	...collaborativeEditingWRM(),
	...confluenceKeyboardShortcutsWRM(),
	...confluenceLabelsWRM(),
	...contentFormattingMacrosWRM(),
	...initTableToolbarWRM(),
	...dragAndDropWRM(),
	...gadgetsWRM(),
	...hipchatEmoticonsWRM(),
	...inviteToEditWRM(),
	...multimediaMacroWRM(),
	...officeConnectorWRM(),
	...propertyPanelImageLinkMacroWRM(),
	...roadmapPlannerWRM(),
	...viewFileMacroWRM(),
	...advancedMacrosWRM(),
	...requestAccessWRM(),
	...locationIconWRM(),
	...createFromTemplateMacroWRM(),
	...taskReportMacroWRM(),
	...teamCalendarWRM(),
	...placeholderJiraWRM(),
];

const WRM_DEPENDENCIES = [
	// Load legacy CSS first to minimise the chance of clobbering new CSS loaded later.
	'wr!confluence.web.resources.colors:colors',
	'wr!com.atlassian.confluence.keyboardshortcuts:confluence-keyboard-shortcuts',
	// This contains property-panel, link-browser, page-editor and many other critical resources.
	'wr!com.atlassian.confluence.editor:editor-resources-conf-frontend',
	//load browser-metrics to make sure it finishes event binding before editor is ready
	'wr!com.atlassian.confluence.plugins.confluence-browser-metrics:editor',
	...pluginDependencies,
];

const pluginInitFunctions = [
	// Order is important, it should match the plugin order of tinymce-adaptor.js
	confList,
	taskList,
	wikiAutoformat,
	deleteCommand,
	confluenceLabels,
	auiWindowManager,
	textPlaceHolder,
	emotions,
	confluencePlugin,
	macroPlaceholder,
	initTableToolbar,
	customToolbar,
	wikiMarkup,
	propertyPanel,
	propertyPanelImageLinkMacro,
	confMonoSpace,
	confluenceKeyboardShortcuts,
	confOfCharmap,
	cursorTarget,
	iOSEditingPlugin,
	aeTable,
	autoConvert,
	clipboardAccess,
	draggable,
	insertFilesPlugin,
	flexToFullSize,
	referrer,
	tableContentWrapper,
	linkBrowser,
	versionComment,
	autoCompleteDate,
	autocompleteMacro,
	stickyTableHeaders,
	leaveComment,
	leaveTemplate,
	searchReplace,
	confluenceDrafts,
	pageLayout,
	viewFileMacro,
	macrobrowser,
	statusMacro,
	dragAndDrop,
	multimediaMacro,
	roadmapPlanner,
	exportGlobalCodeMacroConfig,
	contentFormattingMacros,
	gadgets,
	watchPage, // comment-only plugin
	sortableTables,
	autoresize,
	hipchatEmoticons,
	advancedMacros,
	nofifyWatchers,
	collaborativeEditing,
	officeConnector,
	atlassianConnect,
	editorAnalytics,
	tableAnalytics,
	breadCrumbs,
	inlineComment,
	confindentation,
	inviteToEdit,
	textPattern,
	requestAccess,
	locationIcon,
	adg3Editor,
	exportGlobalBookmarkManager,
	patch_firefox,
	patch_ie,
	persistScrollPositionTransition,
	teamCalendar,
	textColor,
];

/**
 * Run each plugin individually in try/catch block so the impact of a failure is isolated to the plugin only.
 * Note that this isolation is not perfect as plugin dependencies do exist.
 */
const initAllPlugins = () => {
	pluginInitFunctions.forEach((pluginInit, index) => {
		try {
			pluginInit();
		} catch (e) {
			// Do not rethrow this exception so the other plugin keep loading.
			editorPluginAnalytics('initError', {
				fnName: pluginInit.name || index,
				message: e.message || '',
				exceptionName: e.name || '',
			});
			if (process.env.NODE_ENV !== 'production') {
				console.error(`Editor plugin '${pluginInit.name || index}' failed to load`, e);
			}
		}
	});
	return true;
};

/**
 * This prevents plugins to register twice in case something tries to run this module again.
 * It happens in ViewPage -> EditPage scenario, aka quick edit.
 *
 * @see CONFCLOUD-57898
 *
 * @type {boolean}
 */
let isLoaded = false;

/**
 * Loads and initialises editor plugins.
 * Requires `tinymce` to be defined already.
 */
export default () => {
	if (isLoaded) {
		return;
	}

	// Setup Globals attached to Tinymce
	// Ensure legacy VK object is ready before loading WRM legacy plugins that call window.tinymce.VK
	const tinymce = window.tinymce;
	tinymce.VK = tinymce.util.VK;
	tinymce.confluence = tinymce.confluence || {};
	exportMacrobrowserAsGlobal(); // tinymce.confluence.macrobrowser
	exportAjsRteContentAsGlobal(); // window.AJS.Rte.Content (required by WRM resources)
	exportNodeUtilsAsGlobal(); // tinymce.confluence.NodeUtils
	exportMacroUtilsAsGlobal(); // tinymce.confluence.MacroUtils

	// Mark the plugin init as loaded in case someone calls it again
	isLoaded = true;

	// WRM.require returns $.Deferred instance so we can attach .then()
	return WRM.require(WRM_DEPENDENCIES).then(initAllPlugins, () => {
		// This only handles WRM failures. Plugin init exceptions are caught and reported individually.
		editorPluginAnalytics('wrmLoadError', {});
		if (process.env.NODE_ENV !== 'production') {
			console.error('Editor plugin web-resources failed to load, see Network tab');
		}
	});
};
